import React, { useState } from "react";
import { CaretDown, CaretRight, Warning } from "@phosphor-icons/react";
import { Sparkline, TrendDiff } from "./Trend";
import { fmtL100 } from "./monthUtils";

export const StatRow = ({ row, title, subtitle, threshold, testId, details }) => {
  const [open, setOpen] = useState(false);
  const sus = row.is_suspect;
  return (
    <div className={`border ${sus ? "border-red-500 bg-red-50/50" : "border-zinc-200 bg-white"}`} data-testid={testId}>
      <div
        className={`grid grid-cols-[1fr_auto] md:grid-cols-[minmax(160px,1.2fr)_110px_90px_130px_110px] gap-3 items-center px-3 py-2 ${details ? "cursor-pointer hover:bg-zinc-50" : ""}`}
        onClick={() => details && setOpen((o) => !o)}
      >
        <div className="min-w-0 flex items-center gap-2">
          {details && (open ? <CaretDown size={12} weight="bold" /> : <CaretRight size={12} weight="bold" />)}
          <div className="min-w-0">
            <div className="font-bold mono uppercase truncate flex items-center gap-1">
              {sus && <Warning size={14} weight="fill" className="text-red-600 shrink-0" />} {title}
            </div>
            <div className="text-[10px] text-zinc-500 uppercase tracking-widest truncate">{subtitle}</div>
          </div>
        </div>
        <div className={`mono font-bold text-right ${sus ? "text-red-600" : "text-zinc-900"}`} data-testid={`${testId}-avg`}>
          {fmtL100(row.avg_l_per_100)}
        </div>
        <div className="hidden md:block text-right"><TrendDiff diff={row.diff} testId={`${testId}-diff`} /></div>
        <div className="hidden md:block"><Sparkline trend={row.trend} threshold={threshold} testId={`${testId}-spark`} /></div>
        <div className="hidden md:block text-[10px] text-zinc-500 uppercase tracking-widest text-right">
          {row.count} plein{row.count > 1 ? "s" : ""}
          {row.over_count > 0 && <span className="text-red-600 font-bold"> · {row.over_count} &gt; seuil</span>}
          {row.aberrant_count > 0 && <div>{row.aberrant_count} aberrant{row.aberrant_count > 1 ? "s" : ""} exclu{row.aberrant_count > 1 ? "s" : ""}</div>}
        </div>
      </div>
      {open && details && <div className="border-t border-zinc-200 px-3 py-2 bg-white">{details}</div>}
    </div>
  );
};
